(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-bah-splash-bar"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {

// Add smooth scrolling to all links
    $(".section-splash-info a").on('click', function(event) {

// Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") { // Prevent default anchor click behavior
        event.preventDefault();

// Store hash
        var hash = this.hash;

// Using jQuery's animate() method to add smooth page scroll
// The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        if ($(hash).length > 0) {
          $('html, body').animate({scrollTop: $(hash).offset().top}, 1200, function() {

// Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
          });
        } else {
          window.location = section.settings.anchor_page_url
        }
      } // End if
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-bah-vid-gallery"] && !window.DesignMode) return;
  try {
    
        $(document).ready(function () {

            $('.slick-content').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                centerMode: true,
                initialSlide: 1,
                centerPadding: '0',
                arrows: false,
            });
            $(".control-prev").click(function () {
                $(".slick-content").slick("slickPrev");
            });
            $(".control-next").click(function () {
                $(".slick-content").slick("slickNext");
            });
        });
    

  } catch(e) { console.error(e); }
})();
})();
